import React from 'react';
import { useTheme } from 'styled-components';
import ContentLoader from 'react-content-loader';
import PropTypes from 'prop-types';
import { Box, Flex, Text } from 'rebass/styled-components';
import { useSourceDetails } from 'components/organisms/contactDetail/hooks/useSourceDetails';
import { SourceDetails } from 'components/organisms/contactDetail/components/sourceDetails';

export const ContactSourceRender = ({ data, value }) => {
  const { colors } = useTheme();
  const sources = useSourceDetails(value ?? []);

  if (data?.options?.showLoader) {
    return (
      <ContentLoader
        speed={2}
        width={400}
        height={160}
        viewBox="0 0 400 160"
        backgroundColor={colors.neutral[50]}
        foregroundColor={colors.neutral[20]}
      >
        <rect x="20" y="16" rx="3" ry="3" width="80" height="8" />
      </ContentLoader>
    );
  }

  if (!sources.length) {
    return '';
  }

  const firstSource = sources[0];

  return (
    <Flex p="8px" alignItems="center" sx={{ height: '100%', gap: '8px' }}>
      <Text
        sx={{
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          maxWidth: 'calc(100% - 40px)',
        }}
        fontSize="14px"
      >
        {firstSource.title}
      </Text>
      {sources.length > 1 && (
        <SourceDetails
          placement="bottom-end"
          sources={value ?? []}
          trigger={() => (
            <Box
              sx={{
                cursor: 'pointer',
                borderRadius: '99px',
                border: '1px solid',
                borderColor: 'border.subtle',
                bg: 'neutral.0',
                color: 'text.main',
                textDecoration: 'none',
                p: '2px 8px',
                maxHeight: '20px',
                justifyContent: 'center',
                alignItems: 'center',
                display: 'flex',
                minWidth: '32px',
              }}
            >
              <Text>+{sources.length - 1}</Text>
            </Box>
          )}
        />
      )}
    </Flex>
  );
};

ContactSourceRender.propTypes = {
  data: PropTypes.object.isRequired,
  value: PropTypes.array.isRequired,
};
